import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-studios',
  templateUrl: './studios.component.html',
  styleUrls: ['./studios.component.scss'],
})
export class StudiosComponent implements OnInit {

    static componentName = 'StudiosComponent';
    post: any;
    fieldValues: {[k: string]: any} = {};
    fieldSelectors: Array<any> = ['image_gallery'];

    constructor(
        private dataService: DataService,
    ) {}

    getPost(): void {
        this.dataService.getPost('bloomy-studios')
            .subscribe(res => this.post = res);
    }

    getField(field_selector): any {
        this.dataService.getField('bloomy-studios', null, field_selector)
            .subscribe(res => this.fieldValues[field_selector] = res[field_selector]);
    }

    ngOnInit() {
        this.getPost();

        // Fetch all ACF fields
        for (const fieldSelector in this.fieldSelectors) {
            if (this.fieldSelectors.hasOwnProperty(fieldSelector)) {
                this.getField(this.fieldSelectors[fieldSelector]);
            }
        }

        setTimeout(() => {
            if (document.querySelectorAll('.studios-hero').length) {
                document.querySelectorAll('.studios-hero')[0].classList.add('show');
            }
        }, 1300);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/studios/studios.component.ts